var _g, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#73af00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 155.367H0V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828L512 155.367zM0 222.461h512v67.09H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M0 155.371h512v67.09H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.725H8.828A8.829 8.829 0 0 1 0 414.897v-58.262h512v58.262a8.828 8.828 0 0 1-8.828 8.828z",
    fill: "#73af00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffe15a",
    d: "M0 289.551h512v67.09H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M194.207 289.546H8.828A8.829 8.829 0 0 1 0 280.718V97.104a8.829 8.829 0 0 1 8.828-8.828h185.379a8.829 8.829 0 0 1 8.828 8.828v183.614a8.83 8.83 0 0 1-8.828 8.828z",
    fill: "#ff4b55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.335 135.638L86.577 173.89l-40.322.312c-2.21.018-3.127 2.838-1.348 4.151l32.438 23.954-12.163 38.446c-.666 2.108 1.734 3.851 3.531 2.566l32.806-23.448 32.806 23.448c1.799 1.286 4.199-.458 3.531-2.566l-12.163-38.445 32.438-23.954c1.779-1.313.862-4.135-1.348-4.151l-40.322-.312-12.761-38.252c-.7-2.099-3.666-2.099-4.365-.001z",
    fill: "#f5f5f5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.6ffba4b81a685e9ccd8d2d394523320a.svg";
export { ForwardRef as ReactComponent };